import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useHasStripeOverdue = (enabled = false) => {
  const query = useQuery({
    queryKey: [QueryKeys.HAS_STRIPE_OVERDUE],
    queryFn: () => accountRepo.getHasOverdue(),
    enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseHasStripeOverdue = ReturnType<typeof useHasStripeOverdue>;
